import React, {useEffect, useState, useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {Context} from '../../../../Helpers/Auth';
import TablePagination from '../../../TablePagination';
import Spinner from '../../../../components/Spinner';
import {getAniversarios} from '../../../../pages/requests';
import moment from 'moment';

function TableAniversario() {
    const {t} = useTranslation();
    const {isCard, openCards} = useContext(Context);

    const [isMobile, setIsMobile] = useState(false);
    const [aniversariantes, setAniversariantes] = useState([]);

    const [loading, setLoading] = useState(true);

    const ITEMS_PER_PAGE = 10;

    const FORMATO_DATA = 'YYYY-MM-DD';

    const [currentPage, setCurrentPage] = useState(1);
    const [totalLinhas, setTotalLinhas] = useState(0);

    let lang;
    switch (localStorage.getItem('i18nextLng')) {
        case 'pt':
            lang = 'POR';
            break;
        case 'fr':
            lang = 'FRA';
            break;
        case 'en':
            lang = 'ENG';
            break;
        case 'es':
            lang = 'ES'; 
            break;
    }

    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        setLoading(false);
        var promises = [];
        const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
        const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
        promises.push(
            getAniversarios(lang, indexOfFirstItem, indexOfLastItem).then(res => {
                if (res.data.success) {
                    const sortedAniversariantes = res.data.leads.sort((a, b) => {
                        const dateA = moment(a.dataNascimento);
                        const dateB = moment(b.dataNascimento);
                        return dateB - dateA;
                    });

                    setAniversariantes(sortedAniversariantes);
                    setTotalLinhas(res.data.totalAniversarios);
                }
            }),
        );

        Promise.all(promises).finally(() => {
            setLoading(false);
        });
    }, [currentPage]);

    return (
        <div>
            {isMobile || isCard ? (
                <div>
                    <div className="flex bg-gray-100 rounded-t-[8px] dark:bg-gray-600 flex-wrap items-center px-4 py-2">
                        <div className="relative w-full max-w-full flex-grow flex-1 ">
                            <h3 className="font-semibold text-base text-gray-900 dark:text-gray-50 ">{t('aniversarios')}</h3>
                        </div>
                    </div>
                    {aniversariantes?.map((dados, index) => (
                        <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                            <h2 className="mb-0" id="headingOne">
                                <button
                                    className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                    type="button"
                                    data-te-collapse-init
                                    data-te-collapse-collapsed
                                    data-te-target={'#flush-collapseThree' + index}
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree">
                                    <div className="flex flex-row">
                                        {dados.nomeContacto} - {dados.cliente} | {moment(dados.dataNascimento).format(FORMATO_DATA)}
                                    </div>
                                    <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                        </svg>
                                    </span>
                                </button>
                            </h2>
                            <div
                                id={'flush-collapseThree' + index}
                                className={openCards ? 'visible' : '!visible hidden'}
                                data-te-collapse-item
                                aria-labelledby="flush-headingThree"
                                data-te-parent="#accordionFlushExample">
                                <div className="px-5 py-4">
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400  mr-2">{t('nome')}:</div> {dados.nomeContacto}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('cliente')}: </div> {dados.cliente}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('email')}: </div> {dados.email}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('telemovel')}: </div> {dados.telemovel}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('data')}: </div> {moment(dados.dataNascimento).format(FORMATO_DATA)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {loading && (
                        <div className="flex flex-row mt-14 justify-center">
                            <>
                                <Spinner />
                            </>
                        </div>
                    )}

                    <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                        <div>
                            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalLinhas / ITEMS_PER_PAGE)}</span>
                            </span>

                            <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalLinhas}</span>
                            <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                        </div>
                        {totalLinhas != 0 &&   <TablePagination total={totalLinhas} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />}
                    </nav>
                </div>
            ) : (
                <div className="w-full shadow-md overflow-hidden rounded-[8px] shadow-xs">
                    <div className="flex bg-gray-50 dark:bg-gray-800 flex-wrap items-center px-4 py-2">
                        <div className="relative w-full max-w-full flex-grow flex-1 ">
                            <h3 className="font-semibold text-base text-gray-900 dark:text-gray-50 ">{t('aniversarios')}</h3>
                        </div>
                    </div>
                    <div className="w-full overflow-x-auto">
                        <table className="w-full">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b border-t dark:border-gray-700 bg-white dark:text-gray-50 dark:bg-gray-500">
                                    <th className="px-4 py-3">{t('cliente')}</th>
                                    <th className="px-4 py-3">{t('telemovel')}</th>
                                    <th className="px-4 py-3">{t('email')}</th>
                                    <th className="px-4 py-3">{t('anos')}</th>
                                    <th className="px-4 py-3">{t('data')}</th>
                                </tr>
                            </thead>
                            {aniversariantes?.map((dados, ) => (
                               
                            <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
                                <tr className="bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-900 text-gray-700 dark:text-gray-400">
                                    <td className="px-4 py-3">
                                        <div className="flex items-center text-sm">
                                            <div>
                                                <p className="font-semibold dark:text-gray-200">{dados.nomeContacto}</p>
                                                <p className="text-xs text-gray-600 dark:text-gray-400">{dados.cliente}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-4 py-3 text-sm">{dados.telemovel}</td>
                                    <td className="px-4 py-3 text-sm">{dados.email}</td>
                                    <td className="px-4 py-3 text-xs">
                                        <span className="px-2 py-1 font-semibold leading-tight text-green-700 bg-green-100 rounded-full dark:bg-green-700 dark:text-green-100"> {dados.idade} </span>
                                    </td>
                                    <td className="px-4 py-3 text-sm">{moment(dados.dataNascimento).format(FORMATO_DATA)}</td>
                                </tr>
                            </tbody> ))}
                        </table>
                    </div>
                    <nav className="flex items-center justify-between ml-4 p-2 pt-4" aria-label="Table navigation">
                        <div>
                            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalLinhas / ITEMS_PER_PAGE)}</span>
                            </span>

                            <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalLinhas}</span>
                            <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                        </div>
                        {totalLinhas != 0 &&   <TablePagination total={totalLinhas} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />}
                    </nav>
                </div>
            )}
        </div>
    );
}

export default TableAniversario;
